import { LOADALLRETURN,
    LOADRETURN,
    RESETRETURN,
    CHANGERETURNFIELD,SET_NOTIFICATION} from "../constant/constant";
import {pAxios} from "..";


function loadAllPayReturnService(status, projectid,costcenter){

    return new Promise(function (resolve, reject) {

        pAxios({
            "method": "GET",
            "url": `/api/return?status=${status}${projectid?`&projectid=${projectid}`:''}${costcenter?`&costcenter=${costcenter}`:''}`,
            "headers": {
                'content-type': 'application/json'
            }
          
        }).then(response => {

           if(response.data){
                       
               resolve({ type: LOADALLRETURN, payreturn: (response.data) });
           }
        })
            .catch(err => {
                
                reject({ type: SET_NOTIFICATION,notification:{message:"Failed to load return data",variant:"danger",err}  })
            });
    });

}

function loadPayReturnService(id){

  return new Promise(function (resolve, reject) {

      pAxios({
          "method": "GET",
          "url": `/api/return/${id}`,
          "headers": {
              'content-type': 'application/json'
          }
        
      }).then(response => {

         if(response.data){
                     
             resolve({ type: LOADRETURN, payreturn: (response.data) });
         }
      })
          .catch(err => {
              
              reject({ type: SET_NOTIFICATION,notification:{message:"Failed to load return data",variant:"danger",err}  })
          });
  });

}

export function savePayReturnService(data,method){

  return new Promise(function (resolve, reject) {

      pAxios({
          "method": "POST",
          "url": `/api/return`,
          "headers": {
              'content-type': 'application/json'
          },
          "data":JSON.stringify(data)
        
      }).then(response => {

         if(response.data){
               
        //   store.dispatch({
        //     type: SET_NOTIFICATION, notification:
               resolve({ message: `Payment Return ${method==="POST"?"created":"updated"} successfull`, variant: "success", err: "" })
            // });
            // resolve({ type: RESETRETURN});
         }
      })
          .catch(err => {
              
              reject({message:"Failed to save payment return data",variant:"danger",err}  )
          });
  });

}


 export const loadAllPayReturn=({status, projectid, costcenter})=>{

    return dispatch => {

        loadAllPayReturnService(status, projectid, costcenter)
            .then(response => dispatch(response))
            .catch(err => dispatch(err));

    }

}

export const loadPayReturn=(id)=>{

  return dispatch => {

      loadPayReturnService(id)
          .then(response => dispatch(response))
          .catch(err => dispatch(err));
  }
}

  
  

export const changePayReturn=({name,value,model})=>{

  return dispatch => {
    dispatch({type:CHANGERETURNFIELD,name,value,model});
}
  

}

export const resetPayReturn=()=>{

  return dispatch => {
    dispatch({type:RESETRETURN,});
}
  
}



